import { formatNumeral, type FormatNumeralOptions, NumeralThousandGroupStyles } from 'cleave-zen';

const maskNumeralOptions: FormatNumeralOptions = {
	numeralThousandsGroupStyle: NumeralThousandGroupStyles.THOUSAND,
	delimiter: ',',
	numeralDecimalMark: '.',
	numeralDecimalScale: 0,
	stripLeadingZeroes: true,
	numeralPositiveOnly: true,
	prefix: '$'
};

const maskingStrategies: Record<MaskType, (value: string) => string> = {
	currency: (value) => numeralMasked(value)
	// phone
	// percentage
	// etc
};

export enum MaskType {
	CURRENCY = 'currency'
	// PHONE = 'phone',
	// PERCENTAGE = 'percentage'
}

export function getMaskingStrategy(maskType: MaskType): (value: string) => string {
	return maskingStrategies[maskType];
}

export function numeralMasked(value: string | number, options: FormatNumeralOptions = maskNumeralOptions): string {
	if (typeof value !== 'string') {
		value = String(value);
	}

	const sanitizedValue = value.replace(/[^0-9]/g, '');

	return formatNumeral(sanitizedValue, options);
}

export function formatWithCursorTracking(
	input: HTMLInputElement,
	options: FormatNumeralOptions = maskNumeralOptions
): string {
	// get current cursor position
	const cursorPosition = input.selectionStart ?? input.value.length;

	const rawValue = input.value;
	const sanitizedValue = rawValue.replace(/[^0-9]/g, '');
	const maskedValue = formatNumeral(sanitizedValue, options);

	// calculate cursor adjustment
	const delta = maskedValue.length - rawValue.length;

	input.value = maskedValue;

	// update cursor position
	input.setSelectionRange(cursorPosition + delta, cursorPosition + delta);

	return maskedValue;
}
